import { postJson } from "../config/fetch.api";
import OnboardingResponseBody from "./OnboardingResponseBody";

export const postProofOfAddress = async (): Promise<OnboardingResponseBody> =>
  postJson(
    Routes.api_onboarding_proof_of_addresses_path(),
    "",
    false
  )